﻿import {translation} from "@2d-front-monorepo/core";
import {
	initializeMvvmContext,
	LinkButton,
	MvvmButton,
	MvvmDataProvider,
	MvvmTextInput
} from "@2d-front-monorepo/design-library";
import {PermitsMvvmErrorCollector} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import React, {JSX, useCallback} from "react";
import {Link, useNavigate, useSearchParams} from "react-router";
import {HttpContext} from "../../contexts/HttpContext";
import {reloadPermits} from "../../contexts/PermitsContext";
import {useGlobalContext} from "../../hooks/useGlobalContext";
import useEmailRequiredPolicy from "../../policies/emailRequiredPolicy";
import usePasswordRequiredPolicy from "../../policies/passwordRequiredPolicy";
import {PrivateRoutes, PublicRoutes} from "../../routes";

type SignInProps = {
	email: string;
	password: string;
}

export default function SignIn(): JSX.Element {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const email = searchParams.get("email");

	const global = useGlobalContext();

	const context = initializeMvvmContext({
		initialState: () => {
			return {
				email: email ?? "",
				password: ""
			};
		}
	});

	const onSubmit = useCallback(async (data: SignInProps) => {
		const httpContext = HttpContext.getClient();
		await httpContext.authentication.signIn({
			email: data.email,
			password: data.password,
			installationId: global.installation.id,
			languageId: global.languageId
		});

		await reloadPermits();
		navigate(PrivateRoutes.permitsHome);
	}, []);

	return (
		<section className="sign-in full-layout full-layout--centered">
			<MvvmDataProvider<SignInProps> context={context} onSubmit={onSubmit}>
				<h1>{translation(PermitTranslations.sign_in)}</h1>
				<div className="layout vertical gap">
					<PermitsMvvmErrorCollector/>

					<MvvmTextInput type="email"
					               context={context}
					               property="email"
					               autoComplete="email"
					               autoCapitalize="none"
					               label={translation(PermitTranslations.email)}
					               autoFocus={true}
					               validation={useEmailRequiredPolicy()}/>

					<MvvmTextInput type="password"
					               context={context}
					               property="password"
					               autoComplete="current-password"
					               label={translation(PermitTranslations.password)}
					               validation={usePasswordRequiredPolicy(false)}/>

					<MvvmButton kind="primary">
						{translation(PermitTranslations.sign_in)}
					</MvvmButton>

					<LinkButton to={PublicRoutes.welcome}>
						{translation(PermitTranslations.cancel)}
					</LinkButton>

					<Link to={PublicRoutes.forgotPassword}
					      className="form__link">
						{translation(PermitTranslations.sign_in_page__forgot_password)}
					</Link>
				</div>
			</MvvmDataProvider>
		</section>
	)
}
